import { useCallback, useEffect, useState } from "react";

import { globalEvents } from "../../../common/helpers/GlobalEvents";
import { useGlobalEvent } from "../../../common/hooks/useGlobalEvent";
import {
	useCartActions,
	useCartContext,
} from "../../../contexts/CartServiceContext/CartServiceContext";
import { CART_PAGE_EVENT } from "../constants";
import { duplicateCart } from "../helpers";

const refreshPage = () => {
	globalEvents.emit(CART_PAGE_EVENT.REFRESH_PAGE);
};

export const useCartItemQuantity = (index: number) => {
	const { state: cart } = useCartContext((state) => state.cart);

	const [restoreIndex, setRestoreIndex] = useState<number>(-1);

	const actions = useCartActions();

	const updateItemQty = useCallback(
		(index: number, qty: number) => {
			const newcart = duplicateCart(cart);

			newcart[index].quantity = qty;
			actions.UPDATE_CART(newcart);
		},
		[cart]
	);

	const restoreToBeforeRemove = useCallback(
		(index: number) => {
			updateItemQty(index, 1);
			setRestoreIndex(index);
		},
		[updateItemQty]
	);

	useEffect(() => {
		if (restoreIndex < 0) return;
		if (cart[restoreIndex].quantity < 0) return;
		setRestoreIndex(-1);
		refreshPage();
	}, [cart]);

	useGlobalEvent(CART_PAGE_EVENT.RESTORE_TO_BEFORE_REMOVE, restoreToBeforeRemove);

	const updateQuantity = useCallback(
		(qty: number) => {
			if (qty === 0) {
				globalEvents.emit(CART_PAGE_EVENT.REMOVE_ITEM, index);
			}
			updateItemQty(index, qty);
		},
		[updateItemQty, index]
	);

	return {
		updateQuantity,
		restoreToBeforeRemove,
	};
};
